/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
"use strict";

require('./bootstrap');

// jQuery is loaded via bootstrap.js and exposed globally

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
window.$global = {
    today: function() {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = today.getMonth() + 1;
        const dd = today.getDate();
        return yyyy + '-' + this.padLeft(mm, 2) + '-' + this.padLeft(dd, 2);
    },
    addDays: function(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        const yyyy = result.getFullYear();
        const mm = result.getMonth() + 1;
        const dd = result.getDate();
        return yyyy + '-' + this.padLeft(mm, 2) + '-' + this.padLeft(dd, 2);
    },
    initVerticalCenterComps: function() {
        $.each($('.vertical-center'), function() {
            const $parent = $(this).parent();
            const parentHeight = $parent.actual('outerHeight', {includeMargin: false});
            const centerHeight = $(this).actual('outerHeight', {includeMargin: false});
            let marginTop = (parentHeight / 2) - (centerHeight / 2);
            if(marginTop == 1)
                marginTop = 0;
            $(this).css('margin-top', marginTop);
        });
    },
    padLeft: function(nr, n, str) {
        return new Array(n - String(nr).length + 1).join(str || '0') + nr;
    },
    dataURItoBlob: function(dataURI) {
        let byteString;
        if(dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        let ia = new Uint8Array(byteString.length);
        for(let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i);

        return new Blob([ia], {type: mimeString});
    }
};

Array.prototype.remove = function() {
    let what, a = arguments, L = a.length, ax;
    while(L && this.length) {
        what = a[--L];
        while((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};

$(function() {
    window.$global.initVerticalCenterComps();
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js